export default __webpack_public_path__ + "static/media/android.f4a5cab4.svg";